import 'slick-carousel';
import 'magnific-popup';
import 'chosen-js';

import Configurator from './configurator.js';
import ConfiguratorForm from './configurator-form.js';

import Cart from './cart.js';

window.Cart                 = Cart;
window.Configurator         = Configurator;
window.ConfiguratorForm     = ConfiguratorForm;


(function($) {
    $(function() {

        Configurator.init();
        ConfiguratorForm.init();
        Cart.init();
        Cart.bindCartItemEvents();

        $('.chosen-select').chosen();
        $('.mfp-image').magnificPopup({ type: 'image' });
        $('.mfp-inline').magnificPopup({ type: 'inline' });

        jQuery('#debug-popup').on('click', () => {
            ConfiguratorForm.showQuotePopup(VendorData.thankYouMessage || 'Thank you message goes here', true, 12345);
        });


        function positionTooltip(button, tooltipData) {
            const parent     = button.closest('.s-checkboxes');
            const btnPos     = button.position();
            const btnWidth   = button.outerWidth();
            const btnHeight  = button.outerHeight();
            const tipWidth   = tooltipData.outerWidth();
            const parentWidth = parent.outerWidth();

            const fitsRight  = btnPos.left + btnWidth + tipWidth + 8 <= parentWidth;

            if (fitsRight) {
                tooltipData.css({
                    top:  btnPos.top,
                    left: btnPos.left + btnWidth + 8,
                });
            } else {
                tooltipData.css({
                    top:  btnPos.top + btnHeight + 8,
                    left: btnPos.left,
                });
            }
        }

        $(document).on('click', '.tooltip', function(e) {
            e.stopPropagation();
            e.preventDefault();
            const button      = $(this);
            const tooltipData = button.next('.tooltip-data');
            const isActive    = tooltipData.hasClass('active');

            $('.tooltip-data').removeClass('active');

            if (!isActive) {
                tooltipData.addClass('active');
                positionTooltip(button, tooltipData);
            }
        });
        
        

        $(document).on('click', function() {
            $('.tooltip-data').removeClass('active');
        });

        $('#toggle-cart').on('click', function() {
            $('body').toggleClass('cart-open');
        });

        
        $('#create-quote').on('click', function(e) {

            e.preventDefault();
            $(this).closest('.cart-right').fadeOut(300, function() {
                $('.cart-preview h3').fadeOut(200);
                $('.cart-submit-quote').removeClass('hidden');
                $('#firstname').focus();
                $('.cart-left').addClass('full-width');
            });
        });

        function updateBreakpointClass() {
            const width = window.innerWidth;
            const body  = document.body;

            body.classList.remove( 'bp-desktop', 'bp-tablet', 'bp-mobile' );

            if ( width >= 1024 ) {
                body.classList.add( 'bp-desktop' );
            } else if ( width >= 768 ) {
                body.classList.add( 'bp-tablet' );
            } else {
                body.classList.add( 'bp-mobile' );
            }
        }

        function throttle( fn, delay ) {
            let last = 0;
            return function( ...args ) {
                const now = Date.now();
                if ( now - last < delay ) return;
                last = now;
                fn.apply( this, args );
            };
        }

        updateBreakpointClass();
        window.addEventListener( 'resize', throttle( updateBreakpointClass, 150 ) );

    });
})(jQuery);

window.Configurator = Configurator;